import { DownloadStoryVideoMeta, DownloadStoryVideoPayload } from 'types/store/DownloadStoryVideo';
import { createAsyncReducer } from 'utils/Redux';

import { downloadStoryVideoActions } from '../actions';

export default createAsyncReducer<DownloadStoryVideoMeta, DownloadStoryVideoPayload>(downloadStoryVideoActions);
